import { Table, TableContainer } from "@mui/material";
import { FormProvider } from "src/components/hook-form";

import SkeletonTable from "../../../ApiSecrets/SecretsCard/Table/SkeletonTable";
import useCreateRedirectForm from "../hooks/useCreateRedirectForm";
import { useGetRedirects } from "../services/useGetRedirects";
import TableBody from "./TableBody";
import TableHeader from "./TableHeader";

// ----------------------------------------------------------------------

export const RedirectsTable = () => {
	const { data, isLoading } = useGetRedirects();
	const { methods, onSubmit } = useCreateRedirectForm();

	return (
		<FormProvider autocomplete='off' methods={methods} onSubmit={onSubmit}>
			<TableContainer>
				{isLoading && <SkeletonTable />}
				{!isLoading && (
					<Table size='small' sx={{ minWidth: 950 }}>
						<TableHeader />
						<TableBody data={data} reset={methods.reset} />
					</Table>
				)}
			</TableContainer>
		</FormProvider>
	);
};

export default RedirectsTable;
